"use strict";
exports.__esModule = true;
var getRandomInt_1 = require("./getRandomInt");
var getRandomRate_1 = require("./getRandomRate");
var createRows = function (frequency, from, to, isRate) {
    if (frequency === 'DAILY') {
        return Array.from(new Array(to.diff(from, 'days').plus({ days: 1 }).days)).map(function (_, index) {
            var _value = isRate
                ? (0, getRandomRate_1["default"])() < 0.2
                    ? null
                    : (0, getRandomRate_1["default"])()
                : (0, getRandomInt_1["default"])(0, 500) > 400
                    ? (0, getRandomInt_1["default"])(0, 500)
                    : null;
            return {
                column: from.plus({ days: index }).toFormat('yyyy/MM/dd'),
                value: _value ? String(_value) : null
            };
        });
    }
    else if (frequency === 'WEEKLY') {
        return Array.from(new Array(Math.ceil(to.diff(from, 'weeks').plus({ days: 1 }).weeks))).map(function (_, index) {
            var _value = isRate ? (0, getRandomRate_1["default"])() : (0, getRandomInt_1["default"])(0, 500);
            return {
                column: from.plus({ weeks: index }).toFormat('yyyy/MM/dd~'),
                value: String(_value)
            };
        });
    }
    else {
        return Array.from(new Array(Math.ceil(to.diff(from, 'months').plus({ days: 1 }).months))).map(function (_, index) {
            var _value = isRate ? (0, getRandomRate_1["default"])() : (0, getRandomInt_1["default"])(0, 500);
            return {
                column: from.plus({ months: index }).toFormat('yyyy/MM'),
                value: String(_value)
            };
        });
    }
};
exports["default"] = createRows;
